import {fromJS} from "immutable";
import {
  LOAD_AVAILABILITY,
  LOAD_COURIERS,
  ASSIGN_WAREHOUSE_COURIER,
  SET_AVAILABILITY,
  SET_AVAILABILITY_FILTER,
  LOAD_AVAILABILITY_FOR_COUNTRY,
  LOAD_AVAILABILITY_FOR_US_STATE
} from "../actions/ShippingApiActions";
import {
  setSubmitStatus,
  getEntity,
  getEntityCollection,
  setEntityCollection
} from "./helpers";
export {
  getSubmitInfoForCommand
} from "./helpers";

const initialState = fromJS({
  cmdSubmission: {},
  entities: {},
  ids: {},
  availabilityFilter: "europe"
})

const reducer = function(state = initialState, action) {
  switch(action.type) {
    case LOAD_AVAILABILITY.SUCCESS:
      return setEntityCollection(state, "availability", action.entities.availability, action.result.availability);

    case LOAD_COURIERS.SUCCESS:
      return setEntityCollection(state, "couriers", action.entities.courier, action.result.couriers);

    case LOAD_AVAILABILITY_FOR_COUNTRY.SUCCESS:
    case LOAD_AVAILABILITY_FOR_US_STATE.SUCCESS:
      return state.setIn(["entities", "availability", action.result], fromJS(action.entities.availability[action.result]));

    case SET_AVAILABILITY_FILTER:
      return state.set("availabilityFilter", action.filter);

    case SET_AVAILABILITY.SUBMIT:
      return setSubmitStatus(state, "SetAvailability", "submitting");

    case SET_AVAILABILITY.FAILED:
      return setSubmitStatus(state, "SetAvailability", "failed");

    case SET_AVAILABILITY.SUCCESS:
      return setSubmitStatus(state, "SetAvailability", "");


    case ASSIGN_WAREHOUSE_COURIER.SUBMIT:
      return setSubmitStatus(state, "AssignWarehouseCourier", "submitting");
    case ASSIGN_WAREHOUSE_COURIER.FAILED:
      return setSubmitStatus(state, "AssignWarehouseCourier", "failed", action.error);
    case ASSIGN_WAREHOUSE_COURIER.SUCCESS:
      return setSubmitStatus(state, "AssignWarehouseCourier", "");

    default:
      return state;
  }
}

export function getAvailabilityFilter(state) {
  return state.get("availabilityFilter");
}

// Return a list of availability locations.
export function getAvailability(state) {
  return getEntityCollection(state, "availability");
}

// Return a list of availability locations filtered by the current filter.
export function getFilteredAvailability(state) {
  const filter = state.get("availabilityFilter");
  const availability = getAvailability(state);
  if (filter === "") return availability;

  let filterFn = (item) => item.get("region") === filter;
  if (filter === "us") {
    filterFn = (item) => item.get("kind") === "us-state";
  }

  return availability.filter(filterFn);
}

// Get availability with composed Id (kind:code)
export function getAvailabilityWithComposedId(state, composedId) {
  return getEntity(state, "availability", composedId);
}

// Return a list of Courier types.
export function getCouriers(state) {
  return getEntityCollection(state, "couriers");
}

export default reducer;